module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/mapaContainer/mapaContainer.component.html
// module id = ./src/app/mapaContainer/mapaContainer.component.html
// module chunks = main